"use client";

import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type AgentStore = {
  hasHydrated: boolean;
  selectedAgent: string;
  setSelectedAgent: (value: string) => void;
  setHasHydrated: (value: boolean) => void;
};

const initialState = {
  hasHydrated: false,
  selectedAgent: "stella"
};

export const useAgentStore = create<AgentStore>()(
  persist(
    (set) => ({
      ...initialState,
      setSelectedAgent: (value) => set({ selectedAgent: value }),
      setHasHydrated: (value) => set({ hasHydrated: value })
    }),
    {
      name: "stella-ui-agent",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ selectedAgent: state.selectedAgent }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      }
    }
  )
);
